/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-item.vue?vue&type=template&id=da8e72cc&scoped=true&"
import script from "./language-item.vue?vue&type=script&lang=js&"
export * from "./language-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8e72cc",
  null
  
)

export default component.exports